// src/components/Agenda.js
export default function Services() {
    return (
      <div className="p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Conference Agenda</h2>
        <ul className="text-lg list-disc list-inside">
          <li>Occupational Health and Safety Management</li>
          <li>Environmental Protection and Sustainability</li>
          <li>Fire Safety and Disaster Preparedness</li>
          <li>Road Transport Safety</li>
          <li>Chemical Safety and Hazard Control</li>
          <li>Emergency Preparedness and Incident Management</li>
          <li>Legal and Regulatory Compliance</li>
        </ul>
      </div>
    );
  }
  